export const getUploadFileDetails = (state) => state.uploadFile;